module.exports = ".dashhead-toolbar >>> button {\n    margin-left: 5px;\n}"